import React,{ useState, useEffect,useRef,useCallback, useMemo ,useContext} from 'react'
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import {  getAllUsers} from '../../api/axiosUsers';
import { Toast } from 'primereact/toast';
import { AllToasts } from '../../components/Toasts/AllToasts';
import { Button } from 'primereact/button';  
import { useNavigate } from 'react-router-dom';
import DataContext from '../../context/DataContext';
import { Tag } from 'primereact/tag';
import NameAvatar from '../../components/avatars/NameAvatar';
import { getAllRoles } from '../../api/axiosRoles';
import SearchToolBar from '../../components/buttonActions/SearchToolBar';
import { getAllRegions } from '../../api/axiosRegions';
import { Paginator } from 'primereact/paginator';
import { Skeleton } from 'primereact/skeleton';









const ConfimUsers = (

  { setUserConfirmationDialog,
    userConfirmationDialog,
    handleUserConfirmation,
  }
) => {
  const { users, setUsers, roles, setRoles, setFetcherror } = useContext(DataContext);
 
  const toast = useRef(null);
  const navigate = useNavigate()


  const [isLoading, setIsLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);

  const [addItemeDialogVisible, setAddItemDialogVisible] = useState(false);
  
  
  const [regions, setRegions] = useState([]);
  const [districts, setDistricts] = useState([]);
  
  
  
  const [searchTerm, setSearchTerm] = useState("");





  // const NewTitle = "All Users";
  const NewTitle = "";
  useEffect(() => {
    
    getAllUsers(
      setIsLoading,
      setFirst,
      setRows,
      undefined,
      setUsers,
      setTotalCount,
      setFetcherror,
      searchTerm
    )
    getAllRoles(setRoles, setFetcherror);
    getAllRegions(setRegions, setFetcherror);


    
  }, []);

  //  Debounce Function and Search Function
  
  
  const handleInputChangeDBSearch = (value) => setSearchTerm(value);
  
  useEffect(() => {
    const id = setTimeout(() => {
      getAllUsers(
        setIsLoading, setFirst, setRows,
        undefined, setUsers, setTotalCount,
        setFetcherror, searchTerm
      );
    }, 1000);
    return () => clearTimeout(id);
  }, [searchTerm]);


  
  const reversedUsers = React.useMemo(
    () => [...users].reverse(),
    [users]
  );

  const filteredUsers =  reversedUsers?.filter(user => user.role === "ZonalLeader" || user.role === "FriendOfHaki" || user.role === "Monitor")

  
  const handleAllToasts = (statusNum, msg) => {
    AllToasts(statusNum, msg, toast);
  };





  const randomColors = {};
   useEffect(() => {
    users.forEach((user) => {
    randomColors[user.id] = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
    });
   }, [users])
  
  
   const limitOptions = [5, 10, 20, 30, 50, 100, 200, 500];
  const skeletonitems = Array.from({ length: 5 }, (v, i) => i);
  
  const onPageChange = (event) => {
    getAllUsers(
      setIsLoading,
      setFirst,
      setRows,
      event,
      setUsers,
      setTotalCount,
      setFetcherror
    )
}
  
 

  return (

    
    <div className="card">
      <Toast ref={toast} />
      
      <Card title={ NewTitle}>
      <SearchToolBar
          setAddItemDialogVisible={setAddItemDialogVisible}
          globalFilter={searchTerm}
          setGlobalFilter={setSearchTerm}
          searchPlaceholder="Users"
          // createLabel="User"
          handleInputChangeDBSearch={handleInputChangeDBSearch}
        />
        
        {!isLoading && <DataTable
          value={reversedUsers}
          showGridlines
          emptyMessage="No users found"
         
        >
                    
          <Column header="Name" body={(rowData) => (<span><NameAvatar name={rowData.firstname} bgcolor={randomColors[rowData.id]} />  {rowData.firstname} {rowData.lastname}</span>)} sortable></Column>
          <Column header="Email" body={(rowData) => rowData.email} sortable></Column>
          <Column header="Roles" body={(rowData) => (
            <div className='flex flex-row'>
              {rowData.role === "Admin" && <div className='m-1'><Tag severity="danger" value="Admin"></Tag></div>}
              {rowData.role === "Operator" && <div className='m-1'><Tag severity="warning" value="Operator"></Tag></div>}
              {rowData.role === "ZNLeader" && <div className='m-1'><Tag severity="help" value="ZNLeader"></Tag></div>}
              {rowData.role === "Monitor" && <div className='m-1'><Tag severity="info" value="Monitor"></Tag></div>}
              {rowData.role === "Citizen" && <div className='m-1'><Tag severity="success" value="Citizen"></Tag></div>}
              {!["Admin", "Operator", "ZNLeader", "Monitor", "Citizen"].includes(rowData.role) && <div className='m-1'><Tag severity="primary" value={rowData.role}></Tag></div>}
            </div>)} >
                          
          </Column>
          <Column header="Region" body={(rowData) => rowData.region} sortable></Column>
          <Column header="Action" body={(rowData) => (
                            
            <div className='flex flex-row' align="center">
              <Button
                icon="pi pi-user-check"
                outlined
                label='Select'
                severity="success"
                aria-label="Cancel"
                className='px-3 py-1 text-xs mr-2 font-light'
                onClick={() => {
                  handleUserConfirmation(rowData)
                  setUserConfirmationDialog(false)
                }}                 
              />
              
            </div>
                        
          )}>
          </Column>
        </DataTable>}

        
        {isLoading && 
          
          <DataTable value={skeletonitems} className="p-datatable-striped">
          <Column field="S/N" header="S/N" style={{ width: '10%' }} body={<Skeleton />}sortable></Column>
          <Column field="name" header="Name" style={{ width: '15%' }} body={<Skeleton />}sortable></Column>
          <Column field="email" header="Email" style={{ width: '50%' }} body={<Skeleton />}sortable></Column>
          <Column field="roles" header="Roles" style={{ width: '15%' }} body={<Skeleton />}></Column>
          <Column field="region" header="Region" style={{ width: '10%' }} body={<Skeleton />}></Column>
          <Column field="actions" header="Actions" style={{ width: '10%' }} body={<Skeleton />}></Column>
          </DataTable>
          }

          {!isLoading &&
            <Paginator
              first={first}
              rows={rows}
              totalRecords={totalCount}
              rowsPerPageOptions={limitOptions}
              onPageChange={onPageChange}
            />
          } 
                
      </Card>
    </div>
  )
}

export default ConfimUsers